<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<button mat-icon-button
        [disabled]="disabled"
        (click)="printResults()"
        matTooltip="Print">
    <mat-icon svgIcon="print" aria-label="Print"></mat-icon>
</button>
